import GoBackButton from '@/common/components/GoBackButton';
import LogRequestShow from '@/common/components/LogRequestShow';
import useUser from '@/common/hooks/useUser';
import { ChevronsRightIcon } from 'lucide-react';
import { useParams } from 'react-router-dom';

const ActionsHistoryShow = () => {
  const { id } = useParams();

  const { data: user } = useUser({ id: id || '' });

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-x-4 items-center">
          <GoBackButton
            fallback={`/users/${id}/actionsHistory`}
            searchLastRouteFromFallback
          />

          <p className="text-white-400 font-normal">
            {user?.full_name}
          </p>

          <ChevronsRightIcon color="#ffffffb3" />

          <h2>
            Histórico de ação
          </h2>
        </div>
      </div>

      <div className="h-[calc(100vh-64px-32px-40px)]">
        <LogRequestShow />
      </div>
    </div>
  );
};

export default ActionsHistoryShow;
